/** @format */

import { ItemLoaders } from '../../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';
import moment from 'moment';
import i18next from 'i18next';
import { ExportToCsv } from 'export-to-csv';
import { PricelistSchemaConnectorsCollectionInterface } from '../../../../interfaces/api/PricelistSchemaConnectorsCollectionInterface';
import { pricelistSchemaConnectorConstants } from '../../../../modules/pricelists/reducers';
import PricelistSchemaConnectorInterface from '../../../../interfaces/billing/PricelistSchemaConnectorInterface';

interface PricelistSchemaToCsvInterface {
    mainname: string;
    vat: string;
}

export class PricelistSchemaToCsv {
    private readonly itemLoader: ItemLoaders;

    constructor(itemLoader: ItemLoaders) {
        this.itemLoader = itemLoader;
    }

    exportToCsv = (params: { pricelistSchemaId: number; pricelistSchemaName: string }): void => {
        const extendFilter = [];

        extendFilter.push({ name: 'itemsPerPage', value: 99999999 }, { name: 'pricelistSchemaId', value: params.pricelistSchemaId });

        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/pricelist_schema_connectors')),
            pricelistSchemaConnectorConstants.LIST,
            extendFilter,
            [],
            (items: PricelistSchemaConnectorsCollectionInterface): void => {
                this.preparePricelistSchemaCsv(items, params.pricelistSchemaName);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    preparePricelistSchemaCsv = (items: PricelistSchemaConnectorsCollectionInterface, pricelistSchemaName: string): void => {
        const csvList = this.prepareCsvData(items);
        const options = {
            filename: pricelistSchemaName + '_' + moment().format('YYYYMMDD[_]HHmm'),
            fieldSeparator: ';',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: false,
            title: i18next.t('pricelists:h.pricelists_group'),
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: false,
            headers: [i18next.t('pricelists:h.pricelist_schema_element_name'), i18next.t('pricelists:h.vat_amount')],
        };
        const exportCsv = new ExportToCsv(options);
        exportCsv.generateCsv(csvList);
    };

    prepareCsvData = (items: PricelistSchemaConnectorsCollectionInterface): Array<PricelistSchemaToCsvInterface> => {
        const csvList: Array<PricelistSchemaToCsvInterface> = [];
        if (items['hydra:member'] && items['hydra:totalItems'] && items['hydra:totalItems'] > 0) {
            items['hydra:member'].map((item: PricelistSchemaConnectorInterface) => {
                csvList.push({
                    mainname: item.pricelistSchemaElement.mainname,
                    vat: item.pricelistSchemaElement.vat,
                });
            });
        }
        return csvList;
    };
}
